import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function SubCategoryDropdown({
  onChangeDropdown,
  showLabel = true,
  required = false,
  categoryId,
  selectedValue,
  isClearable = true,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (!categoryId) {
        setOptions([]);
        setSelectedOption(null);
        return;
      }
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) return;
        const response = await axios.get(`${baseUrl}/product/subcategories`, {
          params: { CategoryId: categoryId },
        });
        if (response.status === 200 && response.data?.data) {
          const list = response.data.data || [];
          const mapped = list.map((sc) => ({
            value: sc.SubCategoryId?.toString(),
            label: sc.SubCategoryName || `Sub Category ${sc.SubCategoryId}`,
            raw: sc,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load sub categories', err);
      }
    };
    fetchSubCategories();
  }, [categoryId, selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option);
    }
  };

  return (
    <div className="mb-3">
      {showLabel ? (
        <label className="form-label">
          Sub Category
          {required ? <span style={{ color: 'red' }}>*</span> : null}
        </label>
      ) : null}
      <Select
        options={options}
        value={selectedOption}
        onChange={handleChange}
        isClearable={isClearable}
        isDisabled={!categoryId}
        placeholder="Select sub category"
      />
    </div>
  );
}

export default SubCategoryDropdown;
